<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9fcMVT/tc-custom/9781460327340.jpg?1740292047000" alt="This image is the cover for the book Double the Trouble, Billionaires and Babies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Double the Trouble, Billionaires and Babies
      </h1>
      <p class="bookDescription body article font2">
        <b>One night with a billionaire leads to two beautiful babies and a whole heap of trouble in the <i>USA Today</i>–bestselling author’s charming and sexy romance.</b><br/><br/>When billionaire Colton King ended his impetuous marriage to Penny Oaks after just twenty-four hours, he wanted to put the whole things out of his mind for good. But now, more than a year later, Colton discovers Penny’s huge secret—actually two little secrets: a baby boy and a baby girl. <br/><br/>Colton’s only option is to lay claim to his twins. But soon he finds himself laying claim to Penny all over again. Now they have to ask themselves: Was their whirlwind marriage meant to last a lifetime?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maureen Child
      </h2>
      
      <p class="authorDescription body article">Maureen Child is the author of more than 130 romance novels and novellas that routinely appear on bestseller lists and have won numerous awards, including the National Reader&#39;s Choice Award. A&#160;seven-time nominee for the prestigous RITA award from Romance Writers of America, one of her books was made into a CBS-TV movie called THE SOUL COLLECTER.&#160;&#160;Maureen recently moved from&#160;California to the mountains of Utah and is trying to get used to snow.&#160;&#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8b2c8b54